import React from 'react';
import { Button } from '@progress/kendo-react-buttons'
import services from '../../../../services';

class DadosEntidade extends React.Component{
    constructor(props){
        super(props)
        this.state={
        }
    }
    

    estatutosRender=()=>{
        return (this.props.estatutosRes.map((key,index)=>{
            return (<>
                <span className="border p-1 mr-3 mb-2 text-center" style={{minWidth:"25%"}} key={index}>{key}</span>
            </>)
        }))
    }

    render(){
        // console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxx",this.props)
        let {row,entityDetail}= this.props;
        let {estatutosRes} = this.props;
        console.log(row);
        let {dadosDetail} = this.props
        return(
        <>
            <div className="mt-3">
                <div style={{marginRight:"30%"}} className="my-3 ml-3 d-flex k-justify-content-between">
                    <div>
                        <p className="k-mb-0"><strong>nº entidade</strong></p>
                        <p className="k-mb-0">{row['idEntidadeAplicacao'] || 'nd'}</p>
                    </div>
                    <div style={{marginRight:"125px"}}>
                        <Button primary={true}>Ficha de Entidade</Button>
                    </div>
                </div>
                <div className="my-3 ml-3">
                    <p className="k-mb-0"><strong>Entidade</strong></p>
                    <p className="k-mt-0">{row['Entidade'] || 'nd'}</p>
                </div>
                <div className="my-3 ml-3">
                    <p className="k-mb-0"><strong>Tipo de selo</strong></p>
                    <p className="k-mt-0">{row['tipoSelo'] || 'nd'}</p>
                </div>
                <div style={{marginRight:"30%"}} className="my-3  ml-3 d-flex k-justify-content-between">
                        <div>
                            <p className="k-mb-0"><strong>Telefone</strong></p>
                            <p className="k-mb-0">{entityDetail.telephone || "nd"}</p>
                        </div>
                        <div>
                            <p className="k-mb-0"><strong>Fax</strong></p>
                            <p className="k-mb-0">{entityDetail.fax || "nd"}</p>
                        </div>
                        <div >
                            <p className="k-mb-0"><strong>Email</strong></p>
                            <p className="k-mb-0">{entityDetail.email || "nd"}</p>
                        </div>
                    </div>
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Observações</strong></p>
                        <p className="k-mt-0">{row['observacaoAprovacao'] || 'nd'}</p>
                    </div>
                    <div className="my-3 ml-3">
                        <p className="k-mb-0"><strong>Estatutos</strong></p>
                        { estatutosRes &&
                        <div className="d-flex w-25 flex-wrap">
                            {
                                this.estatutosRender()
                            }
                        </div>
                        }
                    </div>
                    <div className="col-md-12 mt-3">
                        <p className="k-mb-0"><strong>Saldo - Selos impressos</strong></p>
                        <table className="w-100 text-center">
                        <thead className="d-flex justify-content-end">
                            <tr className="border w-75 d-flex justify-content-center">
                                <td ><strong>nº de selos disponiveis</strong></td>
                            </tr>
                        </thead>
                        <tbody className="border">
                                <tr className="border d-flex justify-content-around py-2">
                                    <td className="w-25"><strong>Tipo</strong></td>
                                    <td className="w-25"><strong>disponiveis</strong></td>
                                    <td className="w-25"><strong>aplicados</strong></td>
                                    <td className="w-25"><strong>inutilizados</strong></td>
                                </tr>
                           
                            
                                <tr className="border d-flex justify-content-around py-2">
                                    <td className="w-25">{row['tipoSelo'] || 'nd'}</td>
                                    <td className="w-25">{dadosDetail['numeroSelo'] || 'nd'}</td>
                                    <td className="w-25">{dadosDetail['aplicados'] || 'nd'}</td>
                                    <td className="w-25">{dadosDetail['inutilizados'] || 'nd'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
        </>)
    }
}
export default DadosEntidade